export default __webpack_public_path__ + "static/media/li.dfa7b1c9.svg";